import{Skeleton as t}from"@mantine/core";import{jsx as r}from"@emotion/react/jsx-runtime";function e(o){return r(t,{...o})}export{e as Skeleton};
